import React, { useContext, useEffect } from "react"
import { Box, Card, CardHeader, Divider, FormControl, Grid, MenuItem, Select, useMediaQuery, useTheme } from "@mui/material"
import { styled } from "@mui/material/styles"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { ReportTypeEnum } from "../../interfaces/reports.interfaces"
import { ReportTemplateContext } from "../ReportTemplateContextProvider"
import { useTranslation } from "react-i18next"

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: 0,
  "& .MuiTypography-h5": {
    fontSize: "1rem"
  },
  "& .MuiTypography-bodyMedium": {
    fontSize: "0.75rem"
  }
}))
const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 120
}))

interface PeopleAccessListProps {
  reportType: ReportTypeEnum
}

export const PeopleAccessList = ({ reportType }: PeopleAccessListProps) => {
  const { t } = useTranslation()
  const { contextTemplateAuths, setContextTemplateAuths } = useContext(ReportTemplateContext)
  const [readUserReportResult, readUserReportApi] = useApi() as [IApiResult, IApiFunc]
  const readUserReportFeature = readUserReportResult.data
  const theme = useTheme()
  const bigScreen = useMediaQuery(theme.breakpoints.up("lg"))

  useEffect(() => {
    readUserReportApi.get(apiEndpoints.reporting.getusersbyrole.replace("{feature}", allRoles.ReadUserReports))
  }, [])

  useEffect(() => {
    if (readUserReportResult.status !== 2) return
    const initialAccessLevels = readUserReportFeature.map((user: any) => ({
      userId: user.id,
      name: user.name,
      authorizationLevel: contextTemplateAuths.find((auth: any) => auth.userId === user.id)?.authorizationLevel || 0
    }))
    setContextTemplateAuths(initialAccessLevels)
  }, [readUserReportResult])

  const handleSelectChange = (userId: number, value: number) => {
    const newAccessList = contextTemplateAuths.map((auth: any) => {
      if (auth.userId !== userId) return auth
      return { ...auth, authorizationLevel: value }
    })
    setContextTemplateAuths(newAccessList)
  }

  const dataExists = readUserReportFeature !== null && readUserReportFeature !== undefined && readUserReportFeature.length > 0

  return (
    <Box component={Card} px={2} py={3} mt={3}>
      <StyledCardHeader title={t("reports.assign_permissions", "Assign permissions")} />
      <Grid container>
        <Grid item xs={12} lg={10} xl={6} >
          {dataExists && readUserReportFeature.map((user: any, index: number) => (
            <Grid container alignItems="center" key={index} justifyContent="space-between" spacing={2}>
              <Grid item>
                {user.name}
              </Grid>
              <Grid item>
                <StyledFormControl size="small" variant="standard">
                  <Select
                    sx={{ margin: 0 }}
                    labelId="sortby-label"
                    id="userReportTemplateAuths"
                    value={contextTemplateAuths.find((auth: any) => auth.userId === user.id)?.authorizationLevel || 0}
                    onChange={(event) => {
                      let value = event.target.value
                      if (typeof value === "string") value = parseInt(value)
                      handleSelectChange(user.id, value)
                    }}
                  >
                    <MenuItem value={0}>{t("global.none", "None")}</MenuItem>
                    <MenuItem value={1}>{t("global.read", "Read")}</MenuItem>
                    <MenuItem value={2}>{t("global.edit", "Edit")}</MenuItem>
                  </Select>
                </StyledFormControl>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  )
}